"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.events = void 0;
var eventemitter3_1 = require("eventemitter3");
if (!window.__CN_UTILS_EVENTINSTANCE__) {
    window.__CN_UTILS_EVENTINSTANCE__ = new eventemitter3_1.EventEmitter();
}
exports.events = window.__CN_UTILS_EVENTINSTANCE__;
